import { css } from 'aphrodite';
import * as React from 'react';
import { ILeaderboardUser } from '../../../viewModels/gamification';
import { styleSheet } from '../styles';
import { PodiumPosition, Top3Avatar, Top3AvatarGhost } from './Top3Avatar';

interface IProps {
	top10: ILeaderboardUser[];
	asc?: boolean;
}

// Second place stands left of first and third right, so the leader sits in the middle of the podium.
const PODIUM_ORDER: { index: number; position: PodiumPosition }[] = [
	{ index: 1, position: 'second' },
	{ index: 0, position: 'first' },
	{ index: 2, position: 'third' },
];

export const Top3: React.FC<IProps> = ({ top10, asc }) => {
	if (top10.length === 0) {
		return null;
	}

	return (
		<ol aria-label={asc ? 'Bottom three' : 'Top three'} className={css(styleSheet.podium)}>
			{PODIUM_ORDER.map(({ index, position }) => {
				const leader = top10[index];
				return leader ? (
					<Top3Avatar key={position} userReference={leader.userReference} isAsc={asc === true} position={position} />
				) : (
					<Top3AvatarGhost key={position} />
				);
			})}
		</ol>
	);
};
